import { closeIcon } from '../../config/icons';
import { useTheme } from '@mui/material';
import ControlBtn from '../carousel-embla/components/control-btn';
import { TCarouselProps } from '../carousel-embla/types';
import CarouselContentFullscreen from './carousel-content-fullscreen';
import { StyledDialog } from './styles';

export type CarouselEmblaFullscreenProps = {
  open: boolean;
  onClose: () => void;
  startIndex?: number;
  isPreview: boolean;
} & Omit<TCarouselProps, 'variant' | 'content'>;

export function CarouselEmblaFullscreen({
  open,
  onClose,
  urls,
  mainImageUrl,
  startIndex = 0,
  isPreview,
}: CarouselEmblaFullscreenProps) {
  const direction = useTheme().direction;

  return (
    <StyledDialog
      fullScreen
      open={open}
      onClose={onClose}
      dir={direction}
      data-treedistestid="dialog-carousel-fullscreen"
      sx={{
        mt: isPreview ? '46px' : '0',
      }}
    >
      <ControlBtn
        onClick={onClose}
        icon={closeIcon}
        top="15px"
        left="15px"
        data-treedistestid="button-fullscreen-close"
      />
      {urls.length > 0 && (
        <CarouselContentFullscreen
          urls={urls}
          mainImageUrl={mainImageUrl}
          startIndex={startIndex}
        />
      )}
    </StyledDialog>
  );
}
